import { useViewMapQueryParams } from 'hooks/map/useViewMapQueryParams';
import { CustomMapPage } from 'pages/custom/shared/CustomMapPage';
import { S_PageStyle } from 'pages/page/PageStyle';
import { useEffect } from 'react';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const PerFEKT2025BookingPage = (props: Props): JSX.Element => {
    const id = '55a9c573-ef69-4109-9b76-f485f2466307';

    const queryParamData = useViewMapQueryParams();

    useEffect(() => {
        if (queryParamData.language) {
            Localization.setLanguage(queryParamData.language);
        }
    }, [queryParamData, queryParamData.language]);

    return (
        <S_PerFEKT2025BookingPage className={props.className}>
            <CustomMapPage
                disableSimpleGestures={queryParamData.disableSimpleGestures}
                automaticHeader={queryParamData.showHeader}
                interactiveStyle={queryParamData.interactivityType}
                interactiveMessage={false}
                mapId={id}
                mapheimLogo
            />
        </S_PerFEKT2025BookingPage>
    );
};

const S_PerFEKT2025BookingPage = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
`;
